import { useCallback } from "react";
import { useFloatingConciergeUi } from "@/contexts/FloatingConciergeContext";
import { chatQueryFromUrl } from "@/lib/chatBriefFromParams";

/**
 * Open the authed floating concierge from a `/chat?…` URL string
 * without routing through /chat (avoids AuthedChatGate redirect flash).
 */
export function useOpenAuthedConcierge() {
  const { applyConciergeDeepLink } = useFloatingConciergeUi();

  const openFromChatUrl = useCallback(
    (chatUrl: string) => {
      applyConciergeDeepLink(chatQueryFromUrl(chatUrl));
    },
    [applyConciergeDeepLink],
  );

  const openGeneric = useCallback(() => {
    applyConciergeDeepLink(new URLSearchParams());
  }, [applyConciergeDeepLink]);

  return { openFromChatUrl, openGeneric };
}
